<div (scrolled)="onScroll()"
     [infiniteScrollDistance]="2"
     [infiniteScrollThrottle]="10"
     [scrollWindow]="false"
     class="table-wrapper overflow-auto xs:h-[calc(100vh-45rem)] sm:h-[calc(100vh-45rem)] md:h-[calc(100vh-30rem)]"
     infiniteScroll>
  <table (matSortChange)="sortData($event)"
         [class.hidden]="loading && isFirstPage"
         [dataSource]="dataSource"
         mat-table
         matSort>
    <!--      NAME-->
    <ng-container [sticky]="true"
                  matColumnDef="name">
      <th *matHeaderCellDef
          id="name"
          mat-header-cell
          mat-sort-header="name">
        Measurement Name
      </th>
      <td *matCellDef="let eachRow"
          class="w-[15rem] min-w-[15rem] md:w-[20rem] md:min-w-[20rem]"
          mat-cell>
        <span (click)="handleEditMetricOption(eachRow)"
              *ngIf="!nonEditableCode.includes(eachRow.code)"
              class="editable">{{ eachRow.name }}</span>
        <span *ngIf="nonEditableCode.includes(eachRow.code)">{{ eachRow.name }}</span>
      </td>
    </ng-container>
    <!--      STATUS-->
    <ng-container matColumnDef="isActive">
      <th *matHeaderCellDef
          id="isActive"
          mat-header-cell
          mat-sort-header>
        Status
      </th>
      <td *matCellDef="let eachRow"
          class="w-[20rem] min-w-[20rem]"
          mat-cell>
        <div class="flex flex-row gap-[1rem] td-cell items-center">
          <div [ngStyle]="{'background-color':
            measurementStatusColors[eachRow.isActive? 1 : 2]}"
               class="indicator">
          </div>
          <div class="text">
            {{ statusLabelMap[eachRow.isActive ? 1 : 2] }}
          </div>
        </div>
      </td>
    </ng-container>
    <!--      DATE-->
    <ng-container matColumnDef="createdAt">
      <th *matHeaderCellDef
          id="createdAt"
          mat-header-cell
          mat-sort-header>
        Dates Added
      </th>
      <td *matCellDef="let eachRow"
          class="w-[20rem] min-w-[20rem]"
          mat-cell>
        {{ eachRow.createdAt | date:'MM/dd/YYYY' }}
      </td>
    </ng-container>
    <!--      ACTIVE GROUPS-->
    <ng-container matColumnDef="activeGroupCount">
      <th *matHeaderCellDef
          id="activeGroupCount"
          mat-header-cell
          mat-sort-header>
        <div class="pl-[12px]">
          Groups Active
        </div>
      </th>
      <td *matCellDef="let eachRow"
          class="w-[20rem] min-w-[20rem]"
          mat-cell>
        {{ eachRow.activeGroupCount }}
      </td>
    </ng-container>

    <tr *matHeaderRowDef="displayedColumns; sticky: true"
        mat-header-row></tr>
    <tr *matRowDef="let row; columns: displayedColumns;"
        mat-row></tr>

  </table>
  <div *ngIf="loading"
       [ngClass]="{ 'initial': isFirstPage }"
       class="table-loader w-full flex justify-center items-center">
    <mat-spinner/>
  </div>
  <div *ngIf="!loading && !dataSource.data?.length"
       class="no-data flex flex-col justify-center items-center">
    <div class="text">
      No data matching the filter.
    </div>
  </div>
</div>
